export const formatDateForDB = (date: string | Date) => date instanceof Date ? date.toLocaleDateString() : date;

export default formatDateForDB